import AlreadyUploadedDocuments from './AlreadyUploadedDocuments';

export default AlreadyUploadedDocuments;
